import { useState } from 'react';
import { Card, Heading, Container, Button, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import api from '@/utils/api';
import { toaster } from '@/components/ui/toaster';
import { useAuth } from '@/lib/hooks/use-auth';

export default function ResumeSubscription() {
  const { changeWorkspace } = useAuth();
  const [loading, setLoading] = useState(false);
  const { workspaceId } = useParams<{ workspaceId: string }>();

  async function onSubmit() {
    try {
      setLoading(true);
      const response = await api.get(`/workspace/${workspaceId}/resume-subscription`);

      if (response.data.data) {
        const resWorkspace = await api.get(`workspace/${workspaceId}`);
        if (resWorkspace.data.data) {
          changeWorkspace(resWorkspace.data.data);
        }
        toaster.create({
          title: 'Workspace account has been resumed.',
          type: 'success',
        });
        setTimeout(() => {
          setLoading(false);
          window.location.href = `/${workspaceId}/home`;
        }, 1000);
      }
    } catch (err: any) {
      toaster.create({
        title: err.response?.data?.error || 'An error occurred while resuming the subscription.',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container maxW={'xl'}>
      <Card.Root mx={'auto'} width={{ md: '90%' }} maxW={'6xl'}>
        <Card.Header textAlign={'center'} px={0}>
          <Heading size={{ base: 'md', md: 'lg' }}>Resume Subscription</Heading>
        </Card.Header>
        <Card.Body>
          <Text>Welcome back!</Text>
          <Text>Are you sure you want to resume your subscription?</Text>
        </Card.Body>
        <Card.Footer>
          <Button colorPalette='brand' w={'full'} loading={loading} onClick={onSubmit}>
            Resume
          </Button>
        </Card.Footer>
      </Card.Root>
    </Container>
  );
}
